import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { toRoute } from "../../i18n";
import HeaderTitle from "../../components/header/headerTitle/headerTitle";
import Image from "../../components/image";
import { asset } from "../../helpers/dom.helper";
import "./style.scss";
import {OUR_MATERIAL} from './ourMaterialJson'
import { Media, MediaContextProvider } from "../../media";
import ModalDownload from "../itemAndBlog/itemListContainer/modalDownload";

function OurMaterial(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };


  function scrollToSendUsMessage(scrollTo) {
		const sendUsMessage = document.getElementById(scrollTo);
		if (sendUsMessage) {
		  const offset = 80;
		  const top = sendUsMessage.getBoundingClientRect().top + window.scrollY - offset;
		  window.scrollTo({
			top,
			behavior: 'smooth'
		  });
		}
	}

  return (
    <>
      <Helmet>
        <title>Our Materials | Lussopack</title>
        <meta name="description" content="Our Materials | Lussopack" />
        <meta name="keywords" content="Our Materials | Lussopack" />
        <link rel="canonical" href="https://lussopack.com/our-materials/" />  
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"Our Materials"}
        textSubHeader={"Discover our wide range of world class materials "}
        desktopImageUrl={
          "/images/ourMaterial/desktop/Lussopack-Our-Materials-Cover.webp"
        }
        mobileImageUrl={"/images/ourMaterial/mobile/Lussopack-Our-Materials-Cover.webp"}
        isShowOurReference={true}
      />


      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="ourMaterialContainer">
            <h2>Materials</h2>
            <p>Our company proudly offers an extensive array of premium packaging and display materials, tailored to meet the diverse needs of our valued customers. From eco-friendly options that champion sustainability, to cutting-edge designs that enhance product visibility and brand recognition, our materials empower businesses to create impactful and memorable experiences for their customers. With our versatile selection, customers gain the flexibility to elevate their packaging and display strategies, delivering enhanced aesthetics, protection, and functionality while reinforcing their brand's unique identity in the market.</p>
            <div className="materialList">
              {OUR_MATERIAL?.map((mat, index) => (
                <div className="materialItem" key={index}>
                 <Link to={toRoute(mat.path)}>
                    <Image
                      src={asset(`${mat.itemImageDesktop}`)}
                      alt={`${mat.item}`}
                      className="img-fluid"
                    />
                  </Link>
                  <Link to={toRoute(mat.path)}>
                    <h2 className="mt-2 mb-5">{mat.item}</h2>
                  </Link>
                </div>
              ))}
              <div className="materialItem download">
                  <div className="downloadText">
                      <Image
                        src={asset(`/images/ourMaterial/desktop/downloadMaterials.webp`)}
                        alt={`downloadMaterials`}
                        className="img-fluid"
                      />
                    <div className="downloadInnerText">
                      <p>Download Materials Book</p>
                      <a onClick={showModal}>click here to download</a>
                    </div>
                  </div>
                  <button className="quoteBtn" onClick={() => scrollToSendUsMessage("sendUsMessage")}>Request a quote</button>
              </div>
            </div>
          </div>
          <ModalDownload isModalVisible={isModalVisible} onModalClose={() => setIsModalVisible(false)} />

        </Media>
        <Media lessThan="md">
          <div id="ourMaterialContainerMobile">
            <h2>Materials</h2>
            <p>Our company proudly offers an extensive array of premium packaging and display materials, tailored to meet the diverse needs of our valued customers. From eco-friendly options that champion sustainability, to cutting-edge designs that enhance product visibility and brand recognition, our materials empower businesses to create impactful and memorable experiences for their customers. With our versatile selection, customers gain the flexibility to elevate their packaging and display strategies, delivering enhanced aesthetics, protection, and functionality while reinforcing their brand's unique identity in the market.</p>
            <div className="materialList">
              {OUR_MATERIAL?.map((mat, index) => (
                <div className="materialItem" key={index}>
                  <Link to={toRoute(mat.path)}>
                    <Image
                      src={asset(`${mat.itemImageDesktop}`)}
                      alt={`${mat.item}`}
                      className="img-fluid"
                    />
                  </Link>
                  <Link to={toRoute(mat.path)}>
                  <h2 className="mt-2 mb-4">{mat.item}</h2>
                  </Link>
                </div>
              ))}
              <div className="materialItem download">
                  <div className="downloadText">
                      <Image
                        src={asset(`/images/ourMaterial/mobile/downloadMaterials.webp`)}
                        alt={`downloadMaterials`}
                        className="img-fluid"
                      />
                    <div className="downloadInnerText">
                      <p>Download Materials Book</p>
                      <a onClick={showModal}>click here to download</a>
                    </div>
                  </div>
                  <button className="quoteBtn" onClick={() => scrollToSendUsMessage("sendUsMessageMobile")}>Request a quote</button>
              </div>
            </div>
          </div>
          <ModalDownload isModalVisible={isModalVisible} onModalClose={() => setIsModalVisible(false)} />
        </Media>
      </MediaContextProvider>
    </>
  );
}

export default OurMaterial;
